import React, {useEffect, useRef, useState} from "react";
import ListView from "@/components/AntListView";
import './index.scss'
import {objectToQueryParams} from "@/utils/publicFun";
import NFTHeader from "@/components/NFTHeader";
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import Service from "@/view/supperzzle/service";
import qs from "query-string";

/**
 * @description 兑换记录
 */
const ExchangeRecord = () => {
  const [dataSource, setDataSource] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const currentPage = useRef(1);
  const pageSize = useRef(10);
  const { fromGems } = qs.parse(window.location.search);
  const loadData = async (isRefesh=false) => {
    const param = {
      fromGems,
    }
    try {
      isRefesh && showLoading();
      const res = await Service.getExchangeList(param);
      isRefesh && hideLoading();
      console.log(res)
      if (res?.status) {
        const { list = [] } = res.data
        setDataSource(list.reverse())
      }
    } catch (error) {
      isRefesh && hideLoading();
      Toast.show(error);
    }
  }
  const loadMore = async () => {
    currentPage.current += 1;
    await loadData()
  }
  useEffect(()=>{
    loadData(true)
  },[])
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      currentPage.current = 1;
      loadData();
    });
  }
  const addOrChangeAddress = (item) => {
    if(item.address) {
      const param = objectToQueryParams({...item, needShowCount: item.gemsCount});
      window.JsBridge.push('CustomWeb', { uri: `${process.env.REACT_APP_GKT_LINK}/front/activities/lottery/orderDetail?${param}`});
    }else {
      const param = objectToQueryParams({
        idf: 'commonSub',
        activityCode: fromGems ? Service.activityCode2 : Service.activityCode,
        req: item.id,
        name: item.prizeName,
        imgUrl: item.prizeImgUrl,
        productId:item.skuId,
        isChangeName:0,
        needShowCount: item.gemsCount,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
      onDidFocus();
    }
  }
  const renderItem = (item)=> {
    return (
      <div className={'exchange_record_itemContainer'}>
        <div className={'exchange_item_title'}>{item.prizeName}</div>
        <div className="exchange_item_time">{item.createTime}</div>
        {item?.prizeType === 3 && (
          <div className="exchange_item_btn_box">
            <div className="btn_tex" onClick={() => {addOrChangeAddress(item)}}>{item?.address ? `查看订单` : `填写地址领取奖品`}</div>
          </div>
        )}
      </div>
    )
  }

  return (
    <div className={'exchange_record_page'}>
      <NFTHeader midText="兑换记录" bgColor={'#FFFFFF'}/>
      <div className={'exchange_container_record_parts'}>
        <ListView
          dataSource={dataSource}
          renderItem={renderItem}
          hasMore={hasMore}
          onRefresh={()=>{
            currentPage.current = 1;
            loadData()
          }}
          onEndReached={loadMore}
          style={{paddingTop: 120}}
          isLoad={true}
        />
      </div>
    </div>
  )
}
export default ExchangeRecord